import {Nullable, TripleAttributeValue} from '@fl/cmsch-fe-library';

interface MilkingTripleAttribute {
    milkingDayTime: Nullable<number>;
    milkingInterval: Nullable<number>;
    milkingCount: Nullable<number>;
}

/**
 * Converts APC milking fields into the shared triple-attribute value shape.
 *
 * @param x Milking values from an APC report or protocol payload.
 * @returns Triple-attribute value consumed by the shared form field.
 */
export const convertApcReportToTripleAttributeValue = (x: MilkingTripleAttribute): TripleAttributeValue => ({
    left: x.milkingDayTime,
    center: x.milkingInterval,
    right: x.milkingCount,
});
